import React, {Component} from "react";
import lodash from "lodash";
import App from "../App";
import UserTable from "./components/UserTable";
import UserPagination from "./components/UserPagination";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./UserSearch.css";
import UserService from "../services/user-service";
import Loading from "../common/Loading/Loading";
import toastr from "toastr";
import ToastOptions from "../common/toast/toastr-config.js";
import Checkbox from "../common/Checkbox/Checkbox";
import AddButton from "../common/AddButton/AddButton";
import {
    Button,
    FormFeedback,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";
import history from "../history";
import ProductService from "../services/product-service";
import FilterDropDown from "../common/Filter/FilterDropDown";

class UserSearch extends Component {
    mount = false;

    constructor(props) {
        super(props);
        this.state = {
            userProducts: [],
            users: [],
            total_users: 0,
            total_pages: 1,
            per_page: 25,
            page: 0,
            start: 1,
            end: 0,
            filter: "",
            status: "all",
            keyword: "",
            sorting_field: "email",
            sorting_order: 1,
            loading: false,
            isCreateUserModalVisible: false,
            firstName: "",
            lastName: "",
            email: "",
            sendEmail: false,
            employee: false,
            invalidFields: {
                firstName: {
                    invalid: false,
                    message: ""
                },
                lastName: {
                    invalid: false,
                    message: ""
                },
                email: {
                    invalid: false,
                    message: ""
                }
            },
            queryParams: {},
            isInFocus: false
        };

        this.debounceSearch = lodash.debounce(this.queryUsers, 100);
        this.debouncePagination = lodash.debounce(this.changePage, 100);
        this.debouncePerPage = lodash.debounce(this.changePerPage, 100);
    }

    componentWillMount() {

        if (this.props.location.search !== "") {

            let searchQuery = this.props.location.search;
            const searchParams = searchQuery.replace("?", "").split("&").reduce(function (prev, curr, i, arr) {
                const parameter = curr.split("=");
                prev[decodeURIComponent(parameter[0])] = decodeURIComponent(parameter[1]);
                return prev;
            }, {});

            this.setState({
                status: searchParams.status
            })
        }
    }

    componentDidMount() {
        this.mount = true;
        this.fetchProducts();

        if (this.props.location.search !== "") {
            //const searchParams
            let searchQuery = this.props.location.search;
            const searchParams = searchQuery.replace("?","").split("&").reduce(function (prev, curr, i, arr) {
                const parameter = curr.split("=");
                prev[decodeURIComponent(parameter[0])] = decodeURIComponent(parameter[1]);
                return prev;
            },{});

            this.setState({
                per_page: searchParams.per_page,
                page: searchParams.page,
                filter: searchParams.filter,
                keyword: searchParams.keyword,
                sorting_field: searchParams.sorting_field,
                sorting_order: searchParams.sorting_order
            }, () => this.fetchUsers());
        } else {
            history.replace("/users");
            this.fetchUsers();
        }


    }

    componentWillUnmount() {
        this.mount = false;
        this.debounceSearch.cancel();
        this.debouncePagination.cancel();

    }

    /**
     * In order to handle the situation where the user clicks on the Users link in the navigation pane, we want to reset the user list
     * I identified that when this link is clicked, the props.history.action is "PUSH", allowing me to identify a state when to reset the state.
     */
    componentWillReceiveProps(props) {
        if (props.history.action === "PUSH") {
            this.setState({
                filter: "",
                status: "all",
                keyword: "",
                sorting_field: "email",
                sorting_order: 1
            }, this.fetchUsers)
        }
    }

    handleQueryChange = e => {
        if (e.target.value === "") {
            this.setState({keyword: "", page: 0}, () => this.fetchUsers());
        }
        this.setState({keyword: e.target.value});
    };

    handlePageChange = e => {
        this.debouncePagination(e.selected);
    };

    handlePerPage = e => {
        this.debouncePerPage(e.target.value);
    };

    handleCreateDialogToggle = () => {
        this.setState({
            isCreateUserModalVisible: !this.state.isCreateUserModalVisible,
            firstName: "",
            lastName: "",
            email: "",
            sendEmail: false,
            employee: false,
            invalidFields: {
                firstName: {
                    invalid: false,
                    message: ""
                },
                lastName: {
                    invalid: false,
                    message: ""
                },
                email: {
                    invalid: false,
                    message: ""
                }
            },
        });
    }

    fetchProducts = async () => {
        try {
            const allProducts = await ProductService.getAllProducts();
            const userProducts = allProducts.data.products.filter(ap => ap.type === "USER");
            if (this.mount) {
                this.setState({userProducts: userProducts});
            }
        } catch (error) {
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };

    fetchUsers = async () => {
        if (this.mount) {
            this.setState({loading: true});
        }

        const params = {
            per_page: this.state.per_page,
            page: this.state.page,
            filter: this.state.filter,
            status: this.state.status,
            keyword: this.state.keyword ? this.state.keyword.trim() : "",
            sorting_field: this.state.sorting_field,
            sorting_order: this.state.sorting_order
        };

        const query = `?per_page=${params.per_page}&page=${params.page}&filter=${this.state.filter}&status=${this.state.status}&keyword=${this.state.keyword}&sorting_field=${this.state.sorting_field}&sorting_order=${this.state.sorting_order}`;
        history.replace(`${query}`);
        this.setState({queryParams: params});

        try {
            const users = await UserService.getUsersByCriteria(params);
            if (this.mount) {
                this.setState({...users, loading: false});
            }

        } catch (error) {
            this.setState({loading: false});
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };

    changePage = value => {
        if (value >= 0 && value < this.state.total_pages) {
            this.setState({page: value}, () => {
                this.fetchUsers();
            });
        }
    };

    changePerPage = value => {
        this.setState({per_page: value}, () => {
            let numPages = Math.ceil(this.state.total_users / this.state.per_page);
            let currentPage =
                this.state.page > numPages - 1 ? numPages - 1 : this.state.page;
            this.setState({total_pages: numPages, page: currentPage}, () =>
                this.fetchUsers()
            );
        });
    };

    handleUserStatusFilter = value => {
        this.setState({status: value, page: 0}, () => {
            this.fetchUsers();
        });
    };

    queryUsers = value => {
        let keyword = value.replace(/\s/g, "").toLowerCase();
        this.setState({keyword: keyword, page: 0}, () => {
            this.fetchUsers();
        });
    };

    handleSortColumn = field => {
        let order =
            this.state.sorting_field === field ? this.state.sorting_order * -1 : 1;
        this.setState({sorting_field: field, sorting_order: order}, () => {
            this.fetchUsers();
        });
    };

    handleKeyPressSearch = e => {
        if (e.key === "Enter") {
            this.setState({page: 0}, () => {
                this.fetchUsers();
            });
        }
    };

    validateName = (e, nameField) => {
        const newName = e.target.value.trim();
        let isNameInvalid = this.state.invalidFields[nameField].invalid;
        if (newName === "") {
            isNameInvalid = true;
        } else {
            isNameInvalid = false;
        }

        this.setState({
            invalidFields: {
                ...this.state.invalidFields,
                [nameField]: {
                    invalid: isNameInvalid,
                    message: isNameInvalid ? "Required field" : "",
                }
            },
            [nameField]: e.target.value
        });
    }

    validateEmail = (e) => {
        const newEmail = e.target.value.trim();
        let isEmailInvalid = this.state.invalidFields.email.invalid;
        if (newEmail === "") {
            isEmailInvalid = true;
        } else {
            isEmailInvalid = false;
        }

        this.setState({
            invalidFields: {
                ...this.state.invalidFields,
                email: {
                    invalid: isEmailInvalid,
                    message: isEmailInvalid ? "Required field" : "",
                }
            },
            email: newEmail
        });
    }

    createUser = async () => {
        let email = this.state.email.trim();
        let lastName = this.state.lastName.trim();
        let firstName = this.state.firstName.trim();
        let sendEmail = this.state.sendEmail;
        let employee = this.state.employee;

        let user = {
            email,
            firstName,
            lastName,
            sendEmail,
            employee
        };

        try {
            const newUser = await UserService.createUser(user);
            toastr.options = ToastOptions;
            toastr.success("The user has been created.");
            history.push(`/users/${newUser.data.userId}`);
            //  this.handleCreateDialogToggle();
        } catch (error) {
            this.handleErrors(error);
        }
    };

    handleErrors = error => {
        let errorData = error.response.data;
        let statusCode = errorData.error.statusCode;
        let message = errorData.error.message;
        let name = errorData.error.name;

        if (name === "Validation Error") {
            let newState = this.state.invalidFields;

            if (statusCode === 400) {
                let body = errorData.error.body;
                body.forEach(fieldError => {
                    let field = fieldError.field;
                    let message = fieldError.message;

                    if (field === "firstName") {
                        newState.firstName.invalid = true;
                        newState.firstName.message = message;
                    }

                    if (field === "lastName") {
                        newState.lastName.invalid = true;
                        newState.lastName.message = message;
                    }

                    if (field === "email") {
                        newState.email.invalid = true;
                        newState.email.message = message;
                    }
                });
            }

            if (statusCode === 409) {
                let newState = this.state.invalidFields;
                newState.email.invalid = true;
                newState.email.message = message;
            }

            this.setState({invalidFields: newState});
            toastr.options = ToastOptions;
            toastr.error(`${errorData.error.message}.`);
        } else if (name === "Conflict") {
            let newState = this.state.invalidFields;
            if (statusCode === 409) {
                let newState = this.state.invalidFields;
                newState.email.invalid = true;
                newState.email.message = message;
            }

            this.setState({invalidFields: newState});
            toastr.options = ToastOptions;
            toastr.error(`One or more fields are invalid.`);
        } else {
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };

    handleChangeSendEmail = () => {
        this.setState({sendEmail: !this.state.sendEmail});
    }

    handleChangeDTNEmployee = () => {
        this.setState({employee: !this.state.employee});
    }

    onBlur = () => {
        this.setState({isInFocus: false});
    }

    onFocus = () => {
        this.setState({isInFocus: true});
    }

    render() {
        return (
            <App {...this.props}>
                <div className="user-search">
                    <h2>
                        Users
                        <span className="create">
              <AddButton
                  name="Add User"
                  handleCreateDialogToggle={this.handleCreateDialogToggle}
              />
            </span>
                    </h2>
                    <div className="search-header">
                        <div className="search-bar">
                            <InputGroup>
                                <Input
                                    type="search"
                                    name="search"
                                    id="exampleSearch"
                                    placeholder="Search"
                                    value={this.state.keyword ? this.state.keyword : ""}
                                    onChange={this.handleQueryChange}
                                    onKeyPress={event => {
                                        this.handleKeyPressSearch(event);
                                    }}
                                    autoComplete="off"
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                />
                                <InputGroupAddon addonType="append">
                                    <FilterDropDown
                                        options={[
                                            {
                                                value: "all",
                                                label: "All"
                                            },
                                            {
                                                value: "active",
                                                label: "Active"
                                            },
                                            {
                                                value: "inactive",
                                                label: "Inactive"
                                            },
                                        ]}
                                        selectedStatus={this.state.status}
                                        handleAccountsFilter={this.handleUserStatusFilter}
                                    />
                                </InputGroupAddon>
                                <InputGroupAddon addonType="append">
                                    <Button
                                        color="success"
                                        onClick={() => {
                                            this.setState({page: 0}, () => {
                                                this.fetchUsers();
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon icon="search"/>
                                        &nbsp;Search
                                    </Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </div>
                    </div>

                    <Modal isOpen={this.state.isCreateUserModalVisible} size="lg">
                        <ModalHeader toggle={this.handleCreateDialogToggle}>New User</ModalHeader>
                        <ModalBody>
                            <FormGroup className="custom_form">
                                {this.state.firstName !== "" &&
                                <Label
                                    className={this.state.invalidFields.firstName.invalid ? "invalid" : ""}
                                >
                                    First Name
                                </Label>
                                }
                                <Input
                                    type="name"
                                    name="name"
                                    id="auth0_first_name"
                                    placeholder="First Name"
                                    value={this.state.firstName}
                                    onChange={(e) => this.validateName(e, "firstName")}
                                    invalid={this.state.invalidFields.firstName.invalid}
                                    autoComplete="off"
                                />
                                <FormFeedback>{this.state.invalidFields.firstName.invalid ? this.state.invalidFields.firstName.message : "Invalid First Name"}</FormFeedback>
                            </FormGroup>
                            <FormGroup className="custom_form">
                                {this.state.lastName !== "" &&
                                <Label
                                    className={this.state.invalidFields.lastName.invalid ? "invalid" : ""}
                                >
                                    Last Name
                                </Label>
                                }
                                <Input
                                    type="name"
                                    name="name"
                                    id="auth0_last_name"
                                    placeholder="Last Name"
                                    value={this.state.lastName}
                                    onChange={(e) => this.validateName(e, "lastName")}
                                    invalid={this.state.invalidFields.lastName.invalid}
                                    autoComplete="off"
                                />
                                <FormFeedback>{this.state.invalidFields.lastName.invalid ? this.state.invalidFields.lastName.message : "Invalid Last Name"}</FormFeedback>
                            </FormGroup>
                            <FormGroup className="custom_form">
                                {this.state.email !== "" &&
                                <Label
                                    className={this.state.invalidFields.email.invalid ? "invalid" : ""}
                                >
                                    Email
                                </Label>
                                }
                                <Input
                                    type="email"
                                    name="email"
                                    id="auth0_email"
                                    placeholder="Email"
                                    value={this.state.email}
                                    onChange={(e) => this.validateEmail(e)}
                                    invalid={this.state.invalidFields.email.invalid}
                                    autoComplete="off"
                                />
                                <FormFeedback>{this.state.invalidFields.email.invalid ? this.state.invalidFields.email.message : "Invalid Email"}</FormFeedback>
                            </FormGroup>

                            <Checkbox
                                id="auth0_sendEmail"
                                label="Send email"
                                isChecked={this.state.sendEmail}
                                handleChange={this.handleChangeSendEmail}
                            />

                            <Checkbox
                                id="auth0_isemployee"
                                label="DTN Employee"
                                isChecked={this.state.employee}
                                handleChange={this.handleChangeDTNEmployee}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="btn btn-link" onClick={() => this.handleCreateDialogToggle()}>
                                Cancel
                            </Button>
                            <button
                                type="button"
                                className="btn btn-success submit-user-button"
                                onClick={() => this.createUser()}
                                disabled={this.state.invalidFields.firstName.invalid || this.state.invalidFields.lastName.invalid || this.state.invalidFields.email.invalid}
                            >
                                Save
                            </button>
                        </ModalFooter>
                    </Modal>

                    <div className="search-body">
                        {this.state.loading ? (
                            <Loading/>
                        ) : (
                            <div>
                                <UserTable
                                    users={this.state.users}
                                    loading={this.state.loading}
                                    handleSortColumn={this.handleSortColumn}
                                    sortingField={this.state.sorting_field}
                                    sortingOrder={this.state.sorting_order}
                                    userProducts={this.state.userProducts}
                                    queryParams={this.state.queryParams}
                                    isInFocus={this.state.isInFocus}
                                />
                                <UserPagination
                                    page={this.state.page}
                                    total_pages={this.state.total_pages}
                                    handlePageChange={this.handlePageChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </App>
        );
    }
}

export default UserSearch;



// WEBPACK FOOTER //
// ./src/user-search/UserSearch.js